import { render, staticRenderFns } from "./ProfileCardsSquare.vue?vue&type=template&id=2b2a307a&scoped=true&"
import script from "./ProfileCardsSquare.vue?vue&type=script&lang=ts&"
export * from "./ProfileCardsSquare.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileCardsSquare.vue?vue&type=style&index=0&id=2b2a307a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2a307a",
  null
  
)

export default component.exports